import { getI18n } from 'react-i18next';

export const VALIDATION_MANUAL_CASH_LIMIT_EMPTY_CLEARING_HOUSE = 'validation.manualCashLimit.emptyClearingHouse';
export const VALIDATION_MANUAL_CASH_LIMIT_INVALID_CLEARING_HOUSE = 'validation.manualCashLimit.invalidClearingHouse';
export const VALIDATION_MANUAL_CASH_LIMIT_EMPTY_CURRENCY = 'validation.manualCashLimit.emptyCurrency';
export const VALIDATION_MANUAL_CASH_LIMIT_INVALID_CURRENCY = 'validation.manualCashLimit.invalidCurrency';
export const VALIDATION_MANUAL_CASH_LIMIT_EMPTY_MEMBER = 'validation.manualCashLimit.emptyMember';
export const VALIDATION_MANUAL_CASH_LIMIT_INVALID_MEMBER = 'validation.manualCashLimit.invalidMember';
export const VALIDATION_MANUAL_CASH_LIMIT_EMPTY_BEGIN_DATE = 'validation.manualCashLimit.emptyBeginDate';
export const VALIDATION_MANUAL_CASH_LIMIT_BEGIN_DATE_AFTER_END_DATE = 'validation.manualCashLimit.beginDateAfterEndDate';
export const VALIDATION_MANUAL_CASH_LIMIT_BEGIN_DATE_IN_PAST = 'validation.manualCashLimit.beginDateInPast';
export const VALIDATION_MANUAL_CASH_LIMIT_EMPTY_LIMIT_VALUE = 'validation.manualCashLimit.emptyLimitValue';
export const VALIDATION_MANUAL_CASH_LIMIT_INVALID_LIMIT_VALUE = 'validation.manualCashLimit.invalidLimitValue';
export const VALIDATION_MANUAL_CASH_LIMIT_INVALID_DESCRIPTION_LENGTH = 'validation.manualCashLimit.invalidDescriptionLength';

export const createManualCashLimitErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_MANUAL_CASH_LIMIT_EMPTY_CLEARING_HOUSE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-clearing-house-empty');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_INVALID_CLEARING_HOUSE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-clearing-house-invalid');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_EMPTY_CURRENCY:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-currency-empty');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_INVALID_CURRENCY:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-currency-invalid');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_EMPTY_MEMBER:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-member-empty');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_INVALID_MEMBER:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-member-invalid');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_EMPTY_BEGIN_DATE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-begin-date-empty');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_BEGIN_DATE_AFTER_END_DATE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-begin-date-after-end-date');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_BEGIN_DATE_IN_PAST:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-begin-date-in-past');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_EMPTY_LIMIT_VALUE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-value-empty');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_INVALID_LIMIT_VALUE:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-value-invalid');
            break;
        case VALIDATION_MANUAL_CASH_LIMIT_INVALID_DESCRIPTION_LENGTH:
            result = i18n.t('manual-cash-limits.error.manual-cash-limit-invalid-description-length', { maxLetters: parseInt(params[0], 10) });
            break;
        default:
            result = undefined;
    }
    return result;
};
